import { Link } from "react-router-dom";
import { XCircle, Aperture } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center bg-[#050505] px-6">
      <div className="max-w-md w-full text-center border border-white/10 bg-[#0f0f10] p-12">
        <Aperture className="w-8 h-8 text-[#D90429] mx-auto mb-8" />
        <XCircle className="w-16 h-16 text-gray-500 mx-auto mb-6" />
        <h1 className="font-head uppercase text-3xl text-white tracking-tight">Checkout Cancelled</h1>
        <p className="font-body text-gray-400 mt-3">
          No charge was made. Your booking request is still saved — you can complete payment anytime.
        </p>
        <Link
          to="/"
          data-testid="cancel-home-link"
          className="inline-block mt-10 px-8 py-3 bg-[#D90429] hover:bg-[#EF233C] transition-colors text-white uppercase tracking-[0.15em] text-sm"
        >
          Back to Home
        </Link>
      </div>
    </div>
  );
}
